/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import AssignAccountForm from './AssignAccountForm/AssignAccountForm';
import AssignAccountSuccess from './AssignAccountSuccess/AssignAccountSuccess';
import AssignAccountError from './AssignAccountError/AssignAccountError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  actionDrawerStore: TypeActionDrawerStore,
  currentAccountDetails: Object,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class AssignAccount extends React.Component<*> {
  createForm = () => {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;

    const fields: Array<Object> = [
      {
        name: 'selectUser',
        label: t('general:actions.assign_trading_account_to_users'),
        fields: [
          {
            name: 'users',
            label: t('general:user_plural'),
            rules: 'required|array|min:1',
            value: [],
            placeholder: t('general:placeholders.first_last_name'),
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const { users }: Object = data.values().selectUser;

        actionDrawerStore.assignAccount(currentAccountDetails.id, {
          user_emails: users.join(),
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        name: 'assignAccountToUser',
      }
    );
  };

  render(): React.Element<*> {
    const { t, actionDrawerStore, currentAccountDetails }: TypeProps = this.props;

    const asset: Object = this.props.formData;

    const title: string = t('general:actions.assign_trading_account_to_users');

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={title} />
          <AssignAccountError account={currentAccountDetails} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={title} />
          <AssignAccountSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={title} />
        <AssignAccountForm account={currentAccountDetails} form={this.createForm()} />
      </div>
    );
  }
}
